module.exports = __webpack_public_path__ + "media/images/icons/flags/TZ-6c36822dfa7962c3b8e0d0baeafd1b8a.svg";